<template>
  <div
    class="tw-mt-[170px] tw-mb-10 tw-w-full tw-h-full tw-mx-auto tw-z-50 tw-flex tw-justify-center tw-items-center">
    <iframe
      v-if="gameUrlToUse"
      ref="gameIframe"
      class="tw-block tw-w-[90%] tw-h-[70vh] sm:tw-h-[80vh]"
      :src="gameUrlToUse"
      @load="onIframeLoad"></iframe>
    <div v-else class="tw-text-center tw-text-black">
      {{ $t('loadingSportBook') }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gameUrl: null,
      h5GameUrl: null,
      isMobile: false,
    }
  },
  async mounted() {
    try {
      this.isMobile = this.checkIfMobile()

      const apiUrl = new URL(
        'https://staging.agere.games/providers/fb-sports-327'
      )

      apiUrl.searchParams.append('action', 'generateEmbedGameUrl')
      apiUrl.searchParams.append('playerId', '1746528081079')
      apiUrl.searchParams.append('currency', 'USD')
      apiUrl.searchParams.append('language', 'en')
      apiUrl.searchParams.append('casino', 'eQlkspUgItHb94SIVY0DFcGVjDQQAFOa')

      const response = await fetch(apiUrl.toString(), {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      const data = await response.json()

      if (data.gameUrl) {
        this.gameUrl = data.gameUrl
      }
      if (data.h5GameUrl) {
        this.h5GameUrl = data.h5GameUrl
      }

      if (!this.gameUrlToUse) {
        console.error('No appropriate game URL found in response')
      }
    } catch (error) {
      console.error('Error fetching game URL:', error)
    }
  },
  computed: {
    gameUrlToUse() {
      return this.isMobile && this.h5GameUrl ? this.h5GameUrl : this.gameUrl
    },
  },
  methods: {
    checkIfMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    },
    onIframeLoad() {
      const iframe = this.$refs.gameIframe
      const sportId = this.$route.query.sportId
      if (iframe && sportId && sportId != iframe.src?.split('sportId=')[1]) {
        let url = new URL(
          'https://pc.st-newsports.com/index.html#/?type=1&sportId=' + sportId
        )
        iframe.src = url.toString()
      }
    },
  },
}
</script>

<style scoped>
.parent_fbsports {
  padding-top: 136px;
}
</style>
